var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{staticClass:"pa-2 mb-4",style:({ backgroundColor: _vm.color }),attrs:{"cols":"12","sm":"12","md":"12","lg":"12","xl":"12"}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.title)+" "),_c('v-icon',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.icon))])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }